module.exports = __webpack_public_path__ + "img/Scorpio.55889784.svg";